import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { appMessageClose } from '../Actions';
const ComponentMessages = ({ message, onClose }) => {
    if (!message) {
        return null;
    }
    const classes = ['page-message', message.severity];
    return (_jsx("div", Object.assign({ id: "application-messages-container", className: classes.join(' ') }, { children: _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("button", Object.assign({ className: "close", onClick: onClose }, { children: _jsx("svg", Object.assign({ className: "svg-icon" }, { children: _jsx("use", { xlinkHref: "/assets/SVGSpriteSheet.svg#close" }) })) })), _jsx("div", Object.assign({ className: "columns small-12" }, { children: _jsx("h4", { children: message.message }) }))] })) })));
};
ComponentMessages.propTypes = {
    message: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.shape({
            message: PropTypes.string.isRequired,
            severity: PropTypes.string.isRequired
        })
    ]),
    onClose: PropTypes.func.isRequired
};
const mapStateToProps = (state) => {
    let message = false;
    if (state.application.messages && state.application.messages.length > 0) {
        [message] = state.application.messages;
    }
    return { message };
};
const mapDispatchToPros = (dispatch) => ({ onClose: () => dispatch(appMessageClose()) });
export default connect(mapStateToProps, mapDispatchToPros)(ComponentMessages);
